/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Assetsdescription1Inputs */

const id_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catatan distribusi dan media yang dilampirkan ke item sandbox, termasuk artefak yang menghubungkan konten katalog toko ke build yang dapat diunduh.`)
};

const ms_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekod pengedaran dan media yang dilampirkan pada item sandbox, termasuk artefak yang menghubungkan kandungan katalog kedai kepada binaan boleh muat turun.`)
};

const da_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distributions- og medieposter tilknyttet sandbox-items, inklusive artefakter der forbinder butikkatalogindhold til downloadbare builds.`)
};

const de_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertriebs- und Medienaufzeichnungen, die an Sandbox-Items angehängt sind, einschließlich Artefakten, die Store-Kataloginhalte mit herunterladbaren Builds verbinden.`)
};

const en_us2_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore distribution assets, linked artifacts, platforms, and download sizes.`)
};

const es_es2_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explora los assets de distribución, los artefactos vinculados, las plataformas y los tamaños de descarga.`)
};

const es_mx2_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registros de distribución y multimedia adjuntos a ítems del sandbox, incluyendo artefactos que conectan el contenido del catálogo de la tienda con compilaciones descargables.`)
};

const fil_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distribution at media records na naka-attach sa mga item ng sandbox, kasama ang mga artifact na nag-uugnay ng content ng store catalog sa mga nada-download na build.`)
};

const fr_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrements de distribution et ressources multimédia attachés aux items du sandbox, incluant les artefacts qui relient le contenu du catalogue de la vitrine aux compilations téléchargeables.`)
};

const it_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registri di distribuzione e media allegati agli articoli del sandbox, inclusi artefatti che collegano il contenuto del catalogo del negozio alle build scaricabili.`)
};

const hu_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terjesztési és média rekordok a sandbox elemeihez csatolva, beleértve az artefaktumokat, amelyek összekötik a bolt katalógus tartalmát a letölthető build-ekkel.`)
};

const nl_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distributie- en mediarecords gekoppeld aan sandbox-items, inclusief artefacten die winkelcatalogusinhoud verbinden met downloadbare builds.`)
};

const no_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distribusjons- og mediaposter knyttet til sandbox-elementer, inkludert artefakter som kobler butikkens kataloginnhold til nedlastbare builds.`)
};

const pl_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekordy dystrybucji i multimedialne przypisane do elementów sandboxa, w tym artefakty łączące zawartość katalogu sklepowego z kompilacjami do pobrania.`)
};

const pt_br2_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registros de distribuição e assets multimídia anexados a itens do sandbox, incluindo artefatos que conectam o conteúdo do catálogo da loja a builds baixáveis.`)
};

const pt_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registos de distribuição e multimédia associados a itens da sandbox, incluindo artefactos que ligam o conteúdo do catálogo da loja a compilações descarregáveis.`)
};

const ro_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Înregistrări de distribuție și media atașate elementelor sandbox-ului, inclusiv artefacte care conectează conținutul catalogului din magazin cu compilări descărcabile.`)
};

const fi_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jakelu- ja mediatietueet, jotka on liitetty hiekkalaatikon kohteisiin, mukaan lukien artfaktit, jotka yhdistävät kauppakatalogin sisällön ladattaviin koontiversioihin.`)
};

const sv_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distributions- och mediaposter kopplade till sandlådeobjekt, inklusive artefakter som binder butikskatalogens innehåll till nedladdningsbara byggen.`)
};

const vi_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hồ sơ phân phối và phương tiện gắn với mục sandbox, bao gồm artefact kết nối nội dung danh mục cửa hàng với bản dựng có thể tải xuống.`)
};

const tr_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox öğelerine bağlı dağıtım ve medya kayıtları; mağaza katalog içeriğini indirilebilir yapılara bağlayan yapıtlar dahil.`)
};

const cs_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distribuční a mediální záznamy připojené k položkám sandboxu, včetně artefaktů, které propojují obsah katalogu obchodu se stahovatelnými sestaveními.`)
};

const bg_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дистрибуционни и медийни записи, прикачени към обекти на sandbox, включително артефакти, които свързват съдържанието на каталога на магазина с изтегляеми компилации.`)
};

const ru_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изучите дистрибутивные ресурсы, связанные артефакты, платформы и размеры загружаемых файлов.`)
};

const uk_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Записи розповсюдження та медіаресурсів, прив'язані до елементів Sandbox, включаючи артефакти, які з'єднують вміст каталогу магазину із завантажуваними збірками.`)
};

const ar_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجلات التوزيع والوسائط المرتبطة بعناصر Sandbox، بما في ذلك التحف التي تربط محتوى كتالوج المتجر بالبنيات القابلة للتنزيل.`)
};

const hi_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सैंडबॉक्स आइटम से जुड़े वितरण और मीडिया रिकॉर्ड, जिनमें वे कलाकृतियाँ शामिल हैं जो स्टोर कैटलॉग सामग्री को डाउनलोड करने योग्य बिल्ड से जोड़ती हैं।`)
};

const th_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บันทึกการจัดจำหน่ายและสื่อที่แนบกับรายการแซนด์บ็อกซ์ รวมถึงอาร์ทิแฟกต์ที่เชื่อมต่อเนื้อหาแค็ตตาล็อกของร้านค้ากับบิลด์ที่ดาวน์โหลดได้`)
};

const ja_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サンドボックスアイテムに添付された配信およびメディアレコード。ストアカタログコンテンツをダウンロード可能なビルドに接続するアーティファクトを含みます。`)
};

const zh_cn2_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`附加到沙盒物品的发布与媒体记录，包括将商店目录内容连接到可下载构建版本的制品。`)
};

const zh_hant1_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`附加到沙盒物品的發布與媒體記錄，包括將商店目錄內容連線到可下載建置版本的製品。`)
};

const ko_sandboxes_assetsdescription1 = /** @type {(inputs: Sandboxes_Assetsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox 아이템에 연결된 배포 및 미디어 레코드로, 카탈로그 콘텐츠를 다운로드 가능한 빌드에 연결하는 아티팩트를 포함합니다.`)
};

/**
* | output |
* | --- |
* | "Explore distribution assets, linked artifacts, platforms, and download sizes." |
*
* @param {Sandboxes_Assetsdescription1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_assetsdescription1 = /** @type {((inputs?: Sandboxes_Assetsdescription1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Assetsdescription1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_assetsdescription1(inputs)
	if (locale === "ms") return ms_sandboxes_assetsdescription1(inputs)
	if (locale === "da") return da_sandboxes_assetsdescription1(inputs)
	if (locale === "de") return de_sandboxes_assetsdescription1(inputs)
	if (locale === "en-US") return en_us2_sandboxes_assetsdescription1(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_assetsdescription1(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_assetsdescription1(inputs)
	if (locale === "fil") return fil_sandboxes_assetsdescription1(inputs)
	if (locale === "fr") return fr_sandboxes_assetsdescription1(inputs)
	if (locale === "it") return it_sandboxes_assetsdescription1(inputs)
	if (locale === "hu") return hu_sandboxes_assetsdescription1(inputs)
	if (locale === "nl") return nl_sandboxes_assetsdescription1(inputs)
	if (locale === "no") return no_sandboxes_assetsdescription1(inputs)
	if (locale === "pl") return pl_sandboxes_assetsdescription1(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_assetsdescription1(inputs)
	if (locale === "pt") return pt_sandboxes_assetsdescription1(inputs)
	if (locale === "ro") return ro_sandboxes_assetsdescription1(inputs)
	if (locale === "fi") return fi_sandboxes_assetsdescription1(inputs)
	if (locale === "sv") return sv_sandboxes_assetsdescription1(inputs)
	if (locale === "vi") return vi_sandboxes_assetsdescription1(inputs)
	if (locale === "tr") return tr_sandboxes_assetsdescription1(inputs)
	if (locale === "cs") return cs_sandboxes_assetsdescription1(inputs)
	if (locale === "bg") return bg_sandboxes_assetsdescription1(inputs)
	if (locale === "ru") return ru_sandboxes_assetsdescription1(inputs)
	if (locale === "uk") return uk_sandboxes_assetsdescription1(inputs)
	if (locale === "ar") return ar_sandboxes_assetsdescription1(inputs)
	if (locale === "hi") return hi_sandboxes_assetsdescription1(inputs)
	if (locale === "th") return th_sandboxes_assetsdescription1(inputs)
	if (locale === "ja") return ja_sandboxes_assetsdescription1(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_assetsdescription1(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_assetsdescription1(inputs)
	return ko_sandboxes_assetsdescription1(inputs)
});
export { sandboxes_assetsdescription1 as "sandboxes.assetsDescription" }